import React from 'react'

import { DynamicModuleLoader } from 'redux-dynamic-modules-react'

import { MessagesPage } from './MessagesPage'
import { getMessagesModule } from './store/module'

export function ConnectedMessagesPage() {
  return (
    <DynamicModuleLoader modules={[getMessagesModule()]}>
      <MessagesPage />
    </DynamicModuleLoader>
  )
}
